/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

interface IInput {
    resource_data: string;
}

interface IOutput {
    resource_ids: string[];
}

export const saveResource = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.SAVE_RESOURCE, data)
        .then((res: IResponse<IOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'saveResource',
                props: data,
                additionalInfo: {
                    description: 'saveResource fetchData error',
                },
            });
            throw err;
        });
};

export const saveResourceSync = fetchDataSync(saveResource);
